import React from 'react'
//Service import
import service from "./services";
import axios from "axios";


const commonImage = async (file,IsFPGUpload=false,FileLocation, url = '', fileName = '', path) => {
var streetparams;
const apiserve = new service();

if(FileLocation){
  streetparams = IsFPGUpload ? FileLocation.street + "/Program_Guide.pdf" : fileName ? FileLocation.street + "/" + fileName : FileLocation.street + "/" + Math.random().toString(36).substr(2, 9) + file.name
}else{
  streetparams = IsFPGUpload ? apiserve.formbucket.street + "/Program_Guide.pdf" : fileName ? 'assets/' + process.env.REACT_APP_ENVIRONMENT +'/'+ path + "/" + fileName : 'assets/' + process.env.REACT_APP_ENVIRONMENT +'/'+ path + "/" + Math.random().toString(36).substr(2, 9) + file.name
}

  try {
    console.log('url',url, streetparams);
    
    const data = await axios.post(process.env.REACT_APP_SOCKET_API_KEY+'imageUpload', {'image':url,'key': streetparams})
    return data.data.data.filelocation
  } catch (error) {
    console.error('Error:', error);
  }
}    

export default commonImage